import { TemplateData } from './htmlTemplates';

export const keywordFocusTemplate = {
  id: 'keyword-focus',
  name: '关键词聚焦',
  description: '字符级别突出显示，适合关键词密集的内容',
  category: 'keyword-heavy',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: #f8f9fa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 30px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .brand-corner {
          position: absolute;
          top: 15px;
          right: 15px;
          font-size: 16px;
          opacity: 0.5;
        }

        .title {
          font-size: 38px;
          font-weight: 900;
          color: #1a1a1a;
          text-align: center;
          line-height: 1.1;
          margin-bottom: 20px;
          letter-spacing: -0.5px;
        }

        .title-word {
          display: inline-block;
          margin: 0 4px;
          padding: 4px 0;
          position: relative;
        }

        .title-word:nth-child(odd) {
          background: linear-gradient(135deg, ${data.theme.primaryColor}20, ${data.theme.accentColor}20);
          border-radius: 8px;
          padding: 4px 8px;
        }

        .subtitle {
          font-size: 18px;
          color: #444444;
          text-align: center;
          line-height: 1.4;
          font-weight: 400;
          max-width: 300px;
        }

        .highlight-box {
          background: ${data.theme.primaryColor};
          color: white;
          padding: 3px 10px;
          border-radius: 15px;
          font-weight: 600;
          margin: 0 3px;
          font-size: 16px;
        }

        .bottom-accent {
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${data.theme.primaryColor}, ${data.theme.accentColor});
          border-radius: 2px;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="brand-corner">${data.theme.logo}</div>
        <h1 class="title">
          ${data.title.split('').map(char => `<span class="title-word">${char}</span>`).join('')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{2,4})/g, '<span class="highlight-box">$1</span>')}</p>
        <div class="bottom-accent"></div>
      </div>
    </body>
    </html>
  `
};
